import React from "react";
import { ContextLanguage } from "../../../context/Context.Language";
import { TEXT_PATTAYA } from "../../../utils/useConstants";
import { useIsMobile } from "../../../utils/useIsMobile";
import {
  STYLE_BANNER_BLUE,
  STYLE_HEADING_1,
  STYLE_IMG_BANNER_BKK,
  STYLE_MARGIN_TOP,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_READING,
} from "../../../utils/useStyle";
import ProgramGoBack from "../../task/render/Program.GoBack";

const PattayaBanner = () => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();
  return (
    <div
      className={`${STYLE_BANNER_BLUE} ${STYLE_MARGIN_TOP}`}
      style={{
        backgroundImage: isMobile
          ? `url(/images/pty_banner_mb.svg)`
          : `url(/images/bg_blue_contactus.svg)`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "bottom",
        backgroundSize: "cover",
      }}
    >
      {!isMobile && (
        <img
          style={{
            backgroundClip: "content-box",
          }}
          src={"/images/pty_icon_banner.svg"}
          className={`${STYLE_IMG_BANNER_BKK} `}
        />
      )}
      <div className={`${STYLE_PADDING_READING} ${STYLE_MAX_WIDTH_DESKTOP}`}>
        <ProgramGoBack
          marginarrow="md:ml-9"
          title={TEXT_PATTAYA[language]}
          textcolor={`${STYLE_HEADING_1(language)}`}
        />
      </div>
    </div>
  );
};

export default PattayaBanner;
